import { tabKey } from './components/tab-key.js';

window.addEventListener("load", (event) => {
    console.log("DOM fully loaded and parsed");
    tabKey();

    if (document.querySelector('[data-menu-hidden]')) {
        import('./components/menu-hidden.js').then(module => {
            module.menuHidden();
            console.log('menu-hidden active on page');
        }).catch(err => console.error('Error loading menu:', err));
    }
    
    if (document.querySelector('[data-accordion]')) {
        import('./components/accordion.js').then(module => {
            module.accordion();
            console.log('accordion active on page');
        }).catch(err => console.error('Error loading accordion:', err));
    }

    if (document.querySelector('[data-slider]')) {
        import('./components/slider.js').then(module => {
            module.slider();
            console.log('slider active on page');
        }).catch(err => console.error('Error loading slider:', err));
    }

    if (document.querySelector('[data-frontpage-animations]')) {
        import('./components/frontpage-animations.js').then(module => {
            module.frontPageAnimations();
            console.log('Front-page animations active on page');
        }).catch(err => console.error('Error loading frontPageAnimations:', err));
    }

    if (document.querySelector('[data-fade-in]')) {
        import('./components/fade-in.js').then(module => {
            module.fadeIn();
            console.log('Fade in animations active on page');
        }).catch(err => console.error('Error loading fadeIn:', err));
    }

    if (document.querySelector('[data-reveal]')) {
        import('./components/revealanimation.js').then(module => {
            module.revealAnimation();
            console.log('Reveal animation active on page');
        }).catch(err => console.error('Error loading revealAnimation:', err));
    }

});


        

        

  